import React, {ReactNode} from 'react'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Grid} from '@vio/atlas/helpers/Grid'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {bookingErrorMessages} from '@vio/core/src/booking/messages'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {DateAndRoomsText} from '../../search/DateAndRoomsText'
import {ErrorMessagesLayout} from './ErrorMessagesLayout'

interface PropsType {
  checkIn: string
  checkOut: string
  rooms: string
  onClick: () => void
  redirectOffersSlot: ReactNode
  hotelCardSlot: ReactNode
}

export const SoldOutErrorContentLayout = ({
  checkIn,
  checkOut,
  rooms,
  onClick = () => {},
  redirectOffersSlot,
  hotelCardSlot
}: PropsType) => {
  const {brand} = useBrand()

  return (
    <Box padding="s500">
      <Grid gap="s500">
        <ErrorMessagesLayout
          titleSlot={
            <FormattedMessageWrapper
              {...bookingErrorMessages.soldOutTitle}
              values={{brandName: brand.name}}
            />
          }
          descriptionSlot={
            <FormattedMessageWrapper
              {...bookingErrorMessages.soldOutDescription}
            />
          }
        />

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <DateAndRoomsText
            checkIn={checkIn}
            checkOut={checkOut}
            rooms={rooms}
            hasCustomStyle
          />
        </Box>
        <Box paddingTop="s400" paddingBottom="s600">
          {hotelCardSlot}
          {redirectOffersSlot}
        </Box>
      </Grid>

      <Button fullWidth variant="tertiary" onClick={onClick} size="xl">
        <FormattedMessageWrapper
          id="chooseAnotherProperty"
          defaultMessage="Back to property"
        />
      </Button>
    </Box>
  )
}
